export const getPlatinadosGames = (games, limit = 10) => {
  return [...games]
    .filter(g => g.platinado)
    .sort((a, b) => {
      if (b.rating !== a.rating) {
        return b.rating - a.rating;
      }
      return new Date(b.dateFinished || b.createdAt) - new Date(a.dateFinished || a.createdAt);
    })
    .slice(0, limit);
};

export const getTopGamesByRating = (games, limit = 10) => {
  return [...games]
    .sort((a, b) => {
      if (b.rating !== a.rating) {
        return b.rating - a.rating;
      }
      return new Date(b.dateFinished || b.createdAt) - new Date(a.dateFinished || a.createdAt);
    })
    .slice(0, limit);
};

export const getGamesByYear = (games, year) => {
  return games.filter(game => {
    if (!game.dateFinished) return false;
    const gameYear = new Date(game.dateFinished).getFullYear();
    return gameYear === parseInt(year);
  });
};

export const getTopGamesByYear = (games, year, limit = 10) => {
  const gamesFromYear = getGamesByYear(games, year);
  return getTopGamesByRating(gamesFromYear, limit);
};

export const getRecentGames = (games, limit = 10) => {
  return [...games]
    .sort((a, b) => {
      const dateA = new Date(a.createdAt || a.dateFinished);
      const dateB = new Date(b.createdAt || b.dateFinished);
      return dateB - dateA;
    })
    .slice(0, limit);
};

export const getGamesByStatus = (games, status, limit = 10) => {
  return [...games]
    .filter(g => g.status === status)
    .sort((a, b) => {
      if (b.rating !== a.rating) {
        return b.rating - a.rating;
      }
      return new Date(b.dateFinished || b.createdAt) - new Date(a.dateFinished || a.createdAt);
    })
    .slice(0, limit);
};

export const getAvailableYears = (games) => {
  const years = games
    .filter(g => g.dateFinished)
    .map(g => new Date(g.dateFinished).getFullYear());
  return [...new Set(years)].sort((a, b) => b - a);
};

export const getMedalEmoji = (position) => {
  switch(position) {
    case 0: return '🥇';
    case 1: return '🥈';
    case 2: return '🥉';
    default: return `${position + 1}.`;
  }
};

const generateLegacyRankingHTML = (games, title) => {
  const avgRating = games.length > 0 
    ? (games.reduce((acc, g) => acc + g.rating, 0) / games.length).toFixed(1)
    : 0;
  
  const platinadosCount = games.filter(g => g.platinado).length;

  return `
    <div style="
      width: 800px;
      background: linear-gradient(135deg, #1e1b4b 0%, #312e81 50%, #1e1b4b 100%);
      padding: 40px;
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
      color: white;
      border-radius: 20px;
      box-sizing: border-box;
    ">
      <!-- Header -->
      <div style="text-align: center; margin-bottom: 40px;">
        <div style="font-size: 48px; margin-bottom: 10px;">🎮</div>
        <h1 style="font-size: 36px; margin: 0 0 10px 0; font-weight: bold; line-height: 1.2;">
          ${title}
        </h1>
        <p style="font-size: 18px; color: #a78bfa; margin: 0;">
          Já Joguei - ${new Date().getFullYear()}
        </p>
      </div>

      <!-- Rankings -->
      <div style="background: rgba(0,0,0,0.3); border-radius: 15px; padding: 30px;">
        ${games.map((game, index) => `
          <div style="
            display: flex;
            align-items: center;
            padding: ${index < 3 ? '16px' : '12px'};
            margin-bottom: ${index < games.length - 1 ? (index < 3 ? '16px' : '8px') : '0'};
            background: ${index < 3 ? 'rgba(167, 139, 250, 0.2)' : 'rgba(255,255,255,0.05)'};
            border-radius: 12px;
            border-left: 4px solid ${index === 0 ? '#fbbf24' : index === 1 ? '#c0c0c0' : index === 2 ? '#cd7f32' : '#a78bfa'};
            gap: 12px;
          ">
            <!-- Position -->
            <div style="
              font-size: ${index < 3 ? '28px' : '20px'};
              font-weight: bold;
              min-width: 40px;
              text-align: center;
              flex-shrink: 0;
            ">
              ${getMedalEmoji(index)}
            </div>

            <!-- Game Image -->
            ${game.coverImage ? `
              <div style="
                width: ${index < 3 ? '80px' : '60px'};
                height: ${index < 3 ? '80px' : '60px'};
                border-radius: 8px;
                overflow: hidden;
                flex-shrink: 0;
                background: rgba(0,0,0,0.3);
                position: relative;
              ">
                <img 
                  src="${game.coverImage}" 
                  alt="${game.name}"
                  style="
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                  "
                />
                ${game.platinado ? `
                  <div style="
                    position: absolute;
                    top: 2px;
                    right: 2px;
                    background: #fbbf24;
                    color: #000;
                    border-radius: 50%;
                    width: 20px;
                    height: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: 12px;
                  ">🏆</div>
                ` : ''}
              </div>
            ` : `
              <div style="
                width: ${index < 3 ? '80px' : '60px'};
                height: ${index < 3 ? '80px' : '60px'};
                border-radius: 8px;
                flex-shrink: 0;
                background: rgba(0,0,0,0.3);
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 32px;
              ">
                🎮
              </div>
            `}

            <!-- Game Info -->
            <div style="flex: 1; min-width: 0;">
              <div style="
                font-size: ${index < 3 ? '20px' : '16px'}; 
                font-weight: bold; 
                margin-bottom: 4px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
                line-height: 1.3;
              ">
                ${game.name}
              </div>
              <div style="font-size: 12px; color: #d1d5db; display: flex; flex-wrap: wrap; gap: 4px; align-items: center;">
                <span>${game.platform}</span>
                ${game.platinado ? '<span style="color: #fbbf24;">• 🏆 Platinado</span>' : ''}
                ${game.tags && game.tags.length > 0 ? '<span>• ' + game.tags.slice(0, 2).join(', ') + '</span>' : ''}
              </div>
            </div>

            <!-- Rating -->
            <div style="
              text-align: right; 
              flex-shrink: 0;
              min-width: 60px;
            ">
              <div style="font-size: ${index < 3 ? '24px' : '18px'}; font-weight: bold; color: #fbbf24;">
                ${'⭐'.repeat(game.rating)}
              </div>
              <div style="font-size: 12px; color: #d1d5db;">
                ${game.rating}/5
              </div>
            </div>
          </div>
        `).join('')}
      </div>

      <!-- Footer Stats -->
      <div style="
        margin-top: 30px;
        padding: 25px;
        background: rgba(0,0,0,0.3);
        border-radius: 15px;
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 20px;
        text-align: center;
      ">
        <div>
          <div style="font-size: 32px; font-weight: bold; color: #fbbf24;">
            ${avgRating}/5
          </div>
          <div style="font-size: 14px; color: #d1d5db;">
            Nota Média
          </div>
        </div>
        <div>
          <div style="font-size: 32px; font-weight: bold; color: #fbbf24;">
            ${platinadosCount}
          </div>
          <div style="font-size: 14px; color: #d1d5db;">
            🏆 Platinados
          </div>
        </div>
        <div>
          <div style="font-size: 32px; font-weight: bold; color: #34d399;">
            ${games.length}
          </div>
          <div style="font-size: 14px; color: #d1d5db;">
            Jogos
          </div>
        </div>
      </div>

      <!-- Footer -->
      <div style="
        margin-top: 20px;
        text-align: center;
        font-size: 12px;
        color: #9ca3af;
      ">
        Criado com Já Joguei 🎮
      </div>
    </div>
  `;
};

const escapeHTML = (value = '') => String(value)
  .replaceAll('&', '&amp;').replaceAll('<', '&lt;').replaceAll('>', '&gt;')
  .replaceAll('"', '&quot;').replaceAll("'", '&#039;');

export const generateRankingHTML = (games, title) => {
  if (!games.length) return '<div></div>';
  const average = (games.reduce((sum, game) => sum + (game.rating || 0), 0) / games.length).toFixed(1);
  const platinum = games.filter(game => game.platinado).length;
  return `<div style="width:800px;background:#080a0f;color:#f8fafc;padding:52px;font-family:Arial,sans-serif;box-sizing:border-box;">
    <div style="display:flex;align-items:center;justify-content:space-between;border-bottom:1px solid #252a34;padding-bottom:28px;margin-bottom:30px;">
      <div>
        <div style="color:#a3ff12;font-size:11px;font-weight:800;letter-spacing:3px;text-transform:uppercase;margin-bottom:10px;">JÁ JOGUEI · MINHA COLEÇÃO</div>
        <div style="font-size:38px;font-weight:900;letter-spacing:-1.5px;line-height:1.05;max-width:570px;">${escapeHTML(title)}</div>
      </div>
      <div style="width:54px;height:54px;border-radius:18px;background:#a3ff12;color:#080a0f;display:flex;align-items:center;justify-content:center;font-size:26px;">⌁</div>
    </div>
    <div>
      ${games.map((game,index) => `<div style="height:96px;display:flex;align-items:center;gap:18px;border-bottom:1px solid #1e222b;">
        <div style="width:34px;color:${index < 3 ? '#a3ff12' : '#596171'};font-size:18px;font-weight:900;">${String(index+1).padStart(2,'0')}</div>
        <div style="width:66px;height:66px;border-radius:14px;overflow:hidden;background:#171b24;flex:none;">
          ${game.coverImage ? `<img src="${escapeHTML(game.coverImage)}" style="width:100%;height:100%;object-fit:cover;" />` : '<div style="font-size:24px;text-align:center;padding-top:19px;">⌁</div>'}
        </div>
        <div style="flex:1;min-width:0;">
          <div style="font-size:17px;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;">${escapeHTML(game.name)}</div>
          <div style="font-size:10px;color:#737c8d;text-transform:uppercase;letter-spacing:1.5px;margin-top:7px;">${escapeHTML(game.platform)}${game.platinado ? ' · 100% COMPLETO' : ''}</div>
        </div>
        <div style="text-align:right;"><div style="color:#fcd34d;font-size:19px;font-weight:900;">★ ${game.rating || 0}</div><div style="color:#4f5664;font-size:9px;margin-top:4px;">DE 5</div></div>
      </div>`).join('')}
    </div>
    <div style="display:flex;gap:12px;margin-top:30px;">
      <div style="flex:1;padding:18px;border:1px solid #252a34;border-radius:16px;"><div style="color:#737c8d;font-size:9px;letter-spacing:1.5px;">JOGOS</div><div style="font-size:25px;font-weight:900;margin-top:5px;">${games.length}</div></div>
      <div style="flex:1;padding:18px;border:1px solid #252a34;border-radius:16px;"><div style="color:#737c8d;font-size:9px;letter-spacing:1.5px;">NOTA MÉDIA</div><div style="font-size:25px;font-weight:900;margin-top:5px;color:#fcd34d;">${average}</div></div>
      <div style="flex:1;padding:18px;border:1px solid #252a34;border-radius:16px;"><div style="color:#737c8d;font-size:9px;letter-spacing:1.5px;">PLATINADOS</div><div style="font-size:25px;font-weight:900;margin-top:5px;color:#a3ff12;">${platinum}</div></div>
    </div>
    <div style="color:#3f4653;font-size:10px;text-align:center;margin-top:28px;letter-spacing:1px;">CRIADO COM JÁ JOGUEI · ${new Date().getFullYear()}</div>
  </div>`;
};

void generateLegacyRankingHTML;
